<template>
  <button class="edit-btn" @click="$emit('click')">
    <img v-if="!isLoading" :src="saveEmailIcon" alt="Enviar Recordatorio" width="25" height="25" />
    <img v-else :src="loadingIcon" alt="Cargando" width="25" height="25" />
  </button>
</template>

<script setup lang="ts">
import saveEmailIcon from '@/assets/save-icon-blue.svg'
import loadingIcon from '@/assets/mini-loading.gif'

defineProps<{
  isLoading: boolean
}>()
// Puedes agregar props si necesitas personalizar el botón
defineEmits<{
  click: []
}>()
</script>

<style scoped>
.edit-btn {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0px 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.2s;
}
.edit-btn:hover {
  background: #f0f0f0;
}
.edit-icon {
  width: 20px;
  height: 20px;
  fill: #333;
}
</style>
